<template>
  <div class="flex items-center">
    <label v-if="label && labelPosition === 'left'" :for="inputId" class="mr-3 text-sm font-medium text-gray-700 dark:text-gray-300">
      {{ label }}
    </label>

    <button
      type="button"
      role="switch"
      :id="inputId"
      :aria-checked="modelValue"
      :disabled="disabled"
      @click="toggle"
      :class="[
        'relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2',
        modelValue
          ? 'bg-blue-600 focus:ring-blue-500'
          : 'bg-gray-200 dark:bg-gray-700 focus:ring-gray-500',
        disabled ? 'opacity-50 cursor-not-allowed' : '',
        size === 'sm' ? 'h-5 w-9' : 'h-6 w-11'
      ]"
    >
      <span class="sr-only">{{ label || 'Toggle' }}</span>
      <span
        :class="[
          'pointer-events-none inline-block rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
          modelValue
            ? (size === 'sm' ? 'translate-x-4' : 'translate-x-5')
            : 'translate-x-0',
          size === 'sm' ? 'h-4 w-4' : 'h-5 w-5'
        ]"
      ></span>
    </button>

    <label v-if="label && labelPosition === 'right'" :for="inputId" class="ml-3 text-sm font-medium text-gray-700 dark:text-gray-300">
      {{ label }}
    </label>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: null,
  },
  labelPosition: {
    type: String,
    default: 'right',
    validator: (value) => ['left', 'right'].includes(value),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md'].includes(value),
  },
});

const emit = defineEmits(['update:modelValue']);

const inputId = ref(`toggle-${Math.random().toString(36).substring(2, 9)}`);

/**
 * Toggle the switch
 */
const toggle = () => {
  if (!props.disabled) {
    emit('update:modelValue', !props.modelValue);
  }
};
</script>
